module.exports = __webpack_public_path__ + "img/icon_axel.3c5d89e7.svg";